import { ref, getCurrentInstance } from 'vue';

export function useReviewHistory() {
    const { proxy } = getCurrentInstance();
    const $t = proxy.$t;

    const showHistoryDialog = ref(false);
    const historyItem = ref(null);

    const openHistoryDialog = (item) => {
        historyItem.value = item;
        showHistoryDialog.value = true;
    };

    const closeHistoryDialog = () => {
        showHistoryDialog.value = false;
        historyItem.value = null;
    };

    const actionLabel = (action) => {
        const labels = {
            submitted: $t('Content Submitted'),
            approved: $t('Content Approved by Admin'),
            rejected: $t('Content Rejected by Admin'),
            sent_to_client: $t('Article Sent for Client Approval'),
            client_approved: $t('Client Approved'),
            client_rejected: $t('Client Rejected'),
            admin_force_approved: $t('Admin Approved'),
            link_confirmed: $t('Live Link Confirmed'),
            link_updated: $t('Live Link Updated'),
            content_link_added: $t('Google Docs Link Added'),
            content_link_cleared: $t('Google Docs Link Removed'),
        };
        return labels[action] || action;
    };

    const actionSeverityClass = (action) => {
        const map = {
            submitted: 'bg-blue-50 border-blue-200 text-blue-800',
            approved: 'bg-green-50 border-green-200 text-green-800',
            rejected: 'bg-red-50 border-red-200 text-red-800',
            sent_to_client: 'bg-purple-50 border-purple-200 text-purple-800',
            client_approved: 'bg-green-50 border-green-200 text-green-800',
            client_rejected: 'bg-red-50 border-red-200 text-red-800',
            admin_force_approved: 'bg-amber-50 border-amber-200 text-amber-800',
            link_confirmed: 'bg-teal-50 border-teal-200 text-teal-800',
            link_updated: 'bg-orange-50 border-orange-200 text-orange-800',
            content_link_added: 'bg-teal-50 border-teal-200 text-teal-800',
            content_link_cleared: 'bg-red-50 border-red-200 text-red-800',
        };
        return map[action] || 'bg-surface-50 border-surface-200 text-surface-800';
    };

    const actionIcon = (action) => {
        const icons = {
            submitted: 'pi-upload',
            approved: 'pi-check-circle',
            rejected: 'pi-times-circle',
            sent_to_client: 'pi-send',
            client_approved: 'pi-check-circle',
            client_rejected: 'pi-times-circle',
            admin_force_approved: 'pi-shield',
            link_confirmed: 'pi-link',
            link_updated: 'pi-pencil',
            content_link_added: 'pi-file-edit',
            content_link_cleared: 'pi-trash',
        };
        return 'pi ' + (icons[action] || 'pi-circle');
    };

    return {
        showHistoryDialog,
        historyItem,
        openHistoryDialog,
        closeHistoryDialog,
        actionLabel,
        actionSeverityClass,
        actionIcon,
    };
}
